// Generated by ReScript, PLEASE EDIT WITH CARE


var heightMdFull = 738;

var heightMd = 378;

var heightMdCompact = 342;

var heightMdFullCompact = 657;

function viewBox(compactMode, extended) {
  return "0 0 760 " + (
          compactMode ? (
              extended ? String(736) : String(386)
            ) : (
              extended ? String(820) : String(420)
            )
        );
}

var heightXlFull = 820;

var heightXl = 420;

var heightXlCompact = 386;

var heightXlFullCompact = 736;

export {
  heightXlFull ,
  heightXl ,
  heightXlCompact ,
  heightXlFullCompact ,
  heightMdFull ,
  heightMd ,
  heightMdCompact ,
  heightMdFullCompact ,
  viewBox ,
  
}
/* No side effect */
